<template>
  <h1>Festival des 24 heures de l’INSA</h1>
  <p class="subtitle">Charte bénévole - 51ème édition</p>

  <h2>Rappel de la mission de l’association</h2>
  <p>
    L’association <strong>Club des 24 heures de l’INSA</strong> a pour mission
    et objectif l’organisation du Festival des 24h de l’INSA dont la 51ème
    édition a lieu du 22 au 24 mai 2026 sur le campus de la Doua à Villeurbanne.
  </p>
  <p>
    Cette charte a pour objectif de définir les obligations, responsabilités et
    droits des bénévoles. Elle vise à garantir un événement sûr ainsi que son
    bon déroulement et à éviter les dysfonctionnements liés aux absences, au
    non-respect des créneaux horaires, ou au non-respect des consignes données.
    Elle vise également à garantir la sécurité de l'événement face aux violences
    quelles qu’elles soient. Chaque bénévole s’engage à respecter les termes de
    cette charte pour contribuer activement au succès de l’événement. Un esprit
    de collaboration et d’entraide est attendu pour garantir le bon déroulement
    de l’événement.
  </p>

  <h2>Engagements de l’association</h2>
  <p>
    L’association Club des 24 heures de l’INSA représentée par sa Présidente,
    Madame Lori Poyroux, s’engage auprès du·de la bénévole à :
  </p>
  <h3>1. Encadrement et organisation</h3>
  <ul>
    <li>
      Confier au·à la bénévole des responsabilités et missions en lien direct
      avec l’organisation du festival.
    </li>
    <li>
      Proposer des missions adaptées à la condition physique du·de la bénévole.
    </li>
    <li>
      Respecter les horaires et disponibilités indiqués par le·la bénévole.
    </li>
    <li>
      Assurer la transmission claire des informations nécessaires à la bonne
      réalisation des missions.
    </li>
  </ul>
  <h3>2. Conditions d’exercice</h3>
  <ul>
    <li>
      Garantir l’accès aux zones nécessaires à la réalisation des missions.
    </li>
    <li>
      Couvrir par une assurance adéquate les risques d’accidents causés ou subis
      dans le cadre des activités bénévoles.
    </li>
    <li>Fournir un espace de repos et de restauration en marge du festival.</li>
    <li>
      Proposer un accès au festival selon les modalités prévues (tarif réduit
      sur les consommations, accès sur zone en dehors des créneaux).
    </li>
    <li>
      Respecter le droit au repos du·de la bénévole, notamment :
      <ul>
        <li>
          Une limite de 6h consécutives sans pause, sauf accord explicite du·de
          la bénévole concerné·e,
        </li>
        <li>
          Des pauses suffisantes entre les créneaux (au moins 45 minutes),
        </li>
        <li>Une durée de sommeil de 6h minimum sur 24 heures.</li>
      </ul>
    </li>
  </ul>

  <h2>Engagements du·de la bénévole</h2>
  <p>
    Le·la bénévole s’engage auprès de l’association Club des 24 heures de l’INSA
    à respecter les règles suivantes :
  </p>

  <h3>1. Présence et disponibilité</h3>
  <ul>
    <li>
      Être présent·e et ponctuel·le sur l’ensemble des créneaux attribués.
    </li>
    <li>
      Assurer la mission jusqu’à son achèvement ou transmettre clairement l’état
      d’avancement au responsable.
    </li>
    <li>
      Assurer une transition sans rupture entre deux créneaux lorsque
      nécessaire.
    </li>
    <li>
      Informer immédiatement les responsables des bénévoles en cas d’absence
      imprévue (maladie, urgence…).
    </li>
    <li>
      Participer aux réunions d’information et aux actions de formation
      proposées.
    </li>
  </ul>

  <h3>2. Comportement, responsabilité et sécurité</h3>
  <ul>
    <li>
      Adopter un comportement respectueux envers les festivalier·ères, les
      partenaires, les organisateur·ices, les salarié·es et les autres bénévoles
      du festival.
    </li>
    <li>
      Respecter les consignes de sécurité, l’éthique, et le fonctionnement de
      l’association.
    </li>
    <li>
      Respecter les obligations de réserve, tant au sein de l’association qu’en
      dehors. Notamment, ne pas diffuser les informations qui lui sont
      transmises pour la bonne exécution de sa mission, dans le cas où elles
      seraient sensibles ou présenteraient un intérêt pour un tiers.
    </li>
    <li>S’impliquer activement dans les missions et activités confiées.</li>
    <li>
      Maintenir un comportement responsable en toutes circonstances, y compris
      en dehors des créneaux : pas d’alcoolémie dangereuse, de violence
      physique, morale ou VHSSD (Violences et Harcèlements Sexistes, Sexuels et
      Discriminatoires). En dehors de leurs créneaux, signaler tout problème ou
      intervenir si nécessaire, dans la limite de leurs compétences et de leur
      capacité à le faire.
    </li>
    <li>
      S’abstenir de toute consommation de substances pouvant altérer le
      comportement durant les créneaux, ainsi que de toutes substances
      illicites. Tout manquement à cette règle pourra entraîner une sanction
      immédiate.
    </li>
  </ul>

  <h3>3. Respect des biens et des espaces</h3>
  <ul>
    <li>
      Respecter les biens, le matériel, les zones ouvertes ainsi que les zones à
      accès restreint (bars, stockage…).
    </li>
    <li>N’utiliser ces espaces que dans le cadre strict de sa mission.</li>
    <li>
      Ne procéder à aucune prise, utilisation ou déplacement non autorisé de
      matériel (tout acte non autorisé sera considéré comme un vol).
    </li>
    <li>Respecter l’environnement et les consignes de tri sur le festival</li>
  </ul>

  <h3>4. Image et vie collective</h3>
  <ul>
    <li>
      Accorder à toutes les personnes mandatées par le Club des 24 heures de
      l’INSA la permission irrévocable de publier toutes les photographies ou
      vidéos prises de lui·d’elle dans le cadre de ses missions pour
      l’association.
    </li>
    <li>
      Respecter le règlement du camping bénévole lorsqu’il·elle y séjourne.
    </li>
  </ul>

  <h2>Sanctions et non-respect</h2>
  <p>
    En cas de manquement aux engagements ci-dessus ou en cas de danger pour soi
    ou autrui, l’association peut prendre les mesures suivantes :
  </p>
  <ul>
    <li>Rappel à l’ordre ou échange avec le·a responsable.</li>
    <li>Réaffectation de missions ou de créneaux.</li>
    <li>
      Exclusion temporaire ou définitive de l’événement (avec perte des
      avantages bénévoles).
    </li>
  </ul>
  <p>
    En cas de vol, dégradation volontaire ou acte malveillant, le·a bénévole
    pourra être tenu·e responsable et devra réparer les dommages causés.
  </p>
  <p>
    En cas d’accident non intentionnel (sans négligence manifeste), la
    responsabilité du·de la bénévole n’est pas engagée.
  </p>

  <div v-if="shouldSign" class="charter-actions">
    <v-divider />
    <v-checkbox v-model="enableSign" :disabled="props.hasSigned" hide-details>
      <template #label>
        <strong>
          Je reconnais avoir lu et compris les engagements de la charte bénévole
          et m’engage à les respecter.
        </strong>
      </template>
    </v-checkbox>
    <v-btn
      :text="
        props.hasSigned
          ? 'Charte Bénévole signée ✔'
          : 'Signer la Charte Bénévole'
      "
      color="success"
      size="large"
      :disabled="!enableSign || props.hasSigned"
      class="charter-sign-btn"
      @click="signVolunteerCharter"
    />
  </div>
</template>

<script lang="ts" setup>
const emit = defineEmits(["sign"]);

const props = defineProps({
  hasSigned: {
    type: Boolean,
    required: true,
  },
  shouldSign: {
    type: Boolean,
    required: false,
    default: true,
  },
});

const enableSign = ref<boolean>(props.hasSigned);

const signVolunteerCharter = async () => {
  if (!props.shouldSign || !enableSign.value) return;
  emit("sign");
};
</script>

<style lang="scss" scoped>
.charter-actions {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

.charter-sign-btn {
  align-self: center;
}

h1,
h2 {
  text-align: center;
}

h1 {
  margin-bottom: -5px;
}

h2 {
  margin-top: 30px;
  margin-bottom: 10px;
}
h3 {
  font-size: 1.1rem;
  margin-top: 10px;
  margin-bottom: 10px;
}

.subtitle {
  font-style: italic;
  text-align: center;
  font-size: 1.5rem;
}

h2 + p {
  text-indent: 30px;
}

p {
  margin-bottom: 10px;
  font-size: 14px;
  text-align: justify;
}

ul {
  margin-left: 50px;
  margin-top: 0px;
  margin-bottom: 10px;
  font-size: 14px;
  text-align: justify;
  @media screen and (max-width: $mobile-max-width) {
    margin-left: 20px;
  }
}

li {
  margin-bottom: 3px;
}
</style>
